import React from 'react';
import { Container, Button, Card, Form, Row, Col, Spinner } from 'react-bootstrap';
import { useEffect } from 'react';
import { useState } from 'react';
import UsersRequestService from '../../services/users-request';
import ResalesRequestService from '../../services/resales-request';
import { ProfileType } from '../../helpers/Enum/index';
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import DualListBox from 'react-dual-listbox';
import 'react-dual-listbox/lib/react-dual-listbox.css';
import FileUpload from 'components/FileUpload';
import { GroupAddOutlined } from '@material-ui/icons';
import { useUser } from 'models';

export default function(){
  const user_global = useUser();
  const [user, setUser] = useState({});
  const [profile, setProfile] = useState({});
  const [isLoad, setLoad] = useState(false);

  const [logoPreview, setLogoPreview] = useState(null);

  const [languages, setLanguages] = useState([])
  const [areasProfiles, setAreasProfiles] = useState([])
  const [userProfiles, setUserProfiles] = useState(null)
  const [listCompany, setListCompany] = useState([]);
  const [listCompanySelected, setListCompanySelect] = useState({ 1: [], 2: [], 3: [], 4: [] });
  const [imageProfile, setImageProfile] = useState(null)

  const [areaSelected, setAreaSelected] = useState(1);

  const id = user_global.id;

  useEffect(() => {
    //getLanguages();
    //getAreasProfiles();
    if (id) {
      getUser();
      getUserProfile();
      //getUserResales();
    }
    getAreaResales(1);
  }, []);

  const getLanguages = () => {
    let request = UsersRequestService.getLanguages();
    request.then(data => {
      setLanguages(data.data.data);
    });
  };

  const getAreasProfiles = () => {
    let request = UsersRequestService.getAreasProfiles();
    request.then(data => {
      setAreasProfiles(data.data.data);
    });
  };

  const getUser = () => {
    let request = UsersRequestService.getUser(id);
    request.then(response => {
      setLogoPreview(response.data.url_image_profile);
      setUser(response.data);
    });
  };

  const getUserProfile = () => {
    let request = UsersRequestService.getUserProfiles(id);
    request.then(data => {
      let profile = {};
      data.data.data.forEach((p => {
        profile[p.area_id] = p.id;
      }));
      setProfile(profile);
      setUserProfiles(data.data.data)
    });
  };

  const getAreaResales = async (area_id) => {
    let request = ResalesRequestService.getAreaResales(area_id);
    request.then(data => {
      setListCompany(data.data.map(c => {
        return {
          value: c.id,
          label: c.name + ' - ' + c.document.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5")
        };
      }));
    });
  };

  const getUserResales = () => {
    let request = UsersRequestService.getUserResales(id);
    request.then(data => {
      let lcs = { ...listCompanySelected };
      data.data.data.forEach((c => {
        lcs[c.area_id].push(c.id);
      }));
      setListCompanySelect(lcs);
    });
  }

  const inputs = [
    { width: 4, title: 'Nome:', key: 'name' },
    { width: 4, title: 'Sobrenome:', key: 'lastname' },
    { width: 4, title: 'E-mail:', key: 'email' },
    { width: 4, title: 'Telefone:', key: 'phone' },
    { width: 4, title: 'Alias:', key: 'alias' },
    { width: 4, title: 'Idioma:', key: 'language_id', as: 'select', options: languages },
  ];

  const createInputs = () => {
    const getOptions = (options) => {
      return (<>
        <option value='' disabled={true}>Selecione</option>
        {options.map((option, k) => {
          return (<option key={k} value={option.id}>{option.name}</option>)
        })}
      </>)
    }

    return (<>
      {inputs.map((input, k) => {
        return (
          <Col xl={input.width} key={k}>
            <Form.Group>
              <Form.Label>{input.title}</Form.Label>
              <Form.Control
                as={input.as ? input.as : 'input'}
                value={getValue(input.key)}
                onChange={e => setValue(input.key, e.target.value)}
                disabled={true}
              >
                {input.options ? getOptions(input.options) : null}
              </Form.Control>
            </Form.Group>
          </Col>
        );
      })}
    </>);
  }

  const createAreaProfile = () => {
    return (<>
      {areasProfiles.map((area, k) => {
        var checked = false;
        var userProfile_aux = { id: '' };

        if (userProfiles) {
          userProfiles.forEach(userProfile => {
            if (area.id == userProfile.area_id) {
              checked = true;
              userProfile_aux = userProfile;
            }
          });
        }

        return (
          <Col xl="3" key={k}>
            <Card border={areaSelected === area.id ? 'success' : ''} onClick={() => {
              if (areaSelected !== area.id)
                getAreaResales(area.id);
              setAreaSelected(area.id);
            }}>
              <Card.Body>
                <Form>
                  <Form.Check label={area.name} checked={profile[area.id] || profile[area.id] === '' ? true : false}
                    onChange={(e) => {
                      let aux = { ...profile };
                      if (e.target.checked) {
                        aux[area.id] = '';
                      } else {
                        delete aux[area.id];
                        let lcs = { ...listCompanySelected };
                        lcs[area.id] = [];
                        setListCompanySelect(lcs);
                      }
                      setProfile({ ...aux });
                    }} />
                  <h6>Selecione o perfil da região:</h6>
                  <Form.Control
                    disabled={profile[area.id] || profile[area.id] === '' ? false : true}
                    onChange={(e) => {
                      let profile_aux = area.profiles.filter(p => p.id === parseInt(e.target.value))[0];

                      if (profile_aux.profile_type_id === ProfileType.Resale)
                        getAreaResales(area.id);
                      else {
                        setListCompany([]);
                        let lcs = { ...listCompanySelected };
                        lcs[area.id] = [];
                        setListCompanySelect(lcs);
                      }

                      let aux = { ...profile };
                      aux[area.id] = e.target.value
                      setProfile({ ...aux });
                    }}
                    value={profile[area.id]}
                    as="select">
                    <option value=''>Selecione</option>
                    {area.profiles.map((profile, k) => {
                      return (<option value={profile.id} key={k} type_profile={profile.profile_type_id}>{profile.name}</option>)
                    })}
                  </Form.Control>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        );
      })}
    </>);
  }

  const submit = () => {
    setLoad(true);
    let model = [
      { key: 'id' },
      { key: 'name', required: true },
      { key: 'lastname', required: true },
      { key: 'email', required: true },
      { key: 'phone' },
      { key: 'alias' },
      { key: 'language_id', required: true },
    ];
    let erro = {
      status: false,
      erros: []
    };

    const formData = new FormData();

    model.forEach((item) => {
      if (item.required) {
        if (user[item.key] && user[item.key] !== '' && user[item.key] !== null && user[item.key] !== 0)
          formData.append(item.key, user[item.key]);
        else {
          erro.status = true;
          erro.erros.push(item.key + ' required');
        }
      }
      else
        formData.append(item.key, user[item.key] ? user[item.key] : '');
    });

    if (imageProfile)
      formData.append('file', imageProfile);

    formData.append("_method", "put");
    if (!erro.status) {
      UsersRequestService.update(id, formData).then(data => {
        localStorage.setItem('username', data.data.name);
        localStorage.setItem('profile', data.data.profiles[0].name);
        localStorage.setItem('img-user', data.data.url_image_profile);
        setLoad(false);
        window.location.href = window.location.href;
      });
    } else {
      setLoad(false);
    }


  };

  const getValue = (name) => {
    return user[name] ? user[name] : '';
  };

  const setValue = (name, value) => {
    let user_aux = { ...user };
    user_aux[name] = value;
    setUser({ ...user_aux });
  };

  const isResale = () => {
    if (profile && areaSelected) {
      let area_aux = areasProfiles.filter(a => a.id === areaSelected)[0];
      if (area_aux) {
        let profile_aux = area_aux.profiles.filter(p => p.id === parseInt(profile[area_aux.id]))[0];
        if (profile_aux)
          if (profile_aux.profile_type_id === ProfileType.Resale)
            return true;
      }
    }
    return false;
  }

  const getViewProfile = () => (
    <>
      <Card className="mb-3">
        <Card.Body>
          <Row>{createAreaProfile()}</Row>
        </Card.Body>
        {isResale() ? (
          <Card.Body>
            <h6>{'Selecione as revendas atendidas pelo usuário na area ' + areaSelected + ':'}</h6>
            <DualListBox
              className="table"
              canFilter
              filterCallback={(option, filterInput) => {
                if (filterInput === '') {
                  return true;
                }
                return (new RegExp(filterInput, 'i')).test(option.label);
              }}
              filterPlaceholder="Pesquisa"
              options={listCompany}
              selected={listCompanySelected[areaSelected]}
              onChange={(selected) => {
                let lc = { ...listCompanySelected }
                lc[areaSelected] = selected;
                setListCompanySelect({ ...lc });
              }}
              icons={{
                moveLeft: <FontAwesomeIcon icon={faChevronLeft} />,
                moveAllLeft: [
                  <FontAwesomeIcon key={0} icon={faChevronLeft} />,
                  <FontAwesomeIcon key={1} icon={faChevronLeft} />,
                ],
                moveRight: <FontAwesomeIcon icon={faChevronRight} />,
                moveAllRight: [
                  <FontAwesomeIcon key={0} icon={faChevronRight} />,
                  <FontAwesomeIcon key={1} icon={faChevronRight} />,
                ]
              }}
            />
          </Card.Body>
        ) : ''}
      </Card>

    </>
  );


  return (<>
    <Container>
      <Row className="mt-4">
        <GroupAddOutlined className="icon-title" />
        <h5 className="title-dashboard">Minha Conta</h5>
      </Row>
      <Row >
        <Card.Body className="card-dashboard shadow bg-white rounded m-2 p-5 col-12">
          <Form>
            <Row>{createInputs()}</Row>
          </Form>
          <Row>
            <Col xs={12}>
              <Form.Group>
                <Form.Label>Selecione a foto do atendente:</Form.Label>
                <FileUpload
                  file={imageProfile}
                  setFile={setImageProfile}
                  preview={logoPreview}
                  setPreview={setLogoPreview}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row className="col-12">
            {isLoad ? (
              <Spinner animation="border" style={{ color: '#e05c17' }} />
            ) : (
                <Button onClick={() => submit()}>Salvar</Button>
              )}
          </Row>
        </Card.Body>
      </Row>
    </Container>
  </>);
};

